export default "__VITE_ASSET__900b61d5__"